export default "__VITE_ASSET__e3eb2281__"